import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  description: string;
  image: string;
}

export const JournalPaywallCard: React.FC<Props> = ({ description, image }) => {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-[320px] overflow-hidden rounded-[20px] bg-popover shadow-card contrast:border contrast:border-border">
      <img
        src={image}
        alt=""
        className="absolute inset-y-0 right-0 left-1/2 h-full w-1/2 object-contain object-right-bottom"
      />
      <div className="relative flex flex-col gap-3 p-8">
        <h3 className="text-title-24 text-foreground">
          {t('overview.journals.paywall.title')}
        </h3>
        <p className="text-body-14 text-subtle-foreground">{description}</p>
      </div>
    </div>
  );
};
